import * as React from 'react';
import * as styles from './questions-answers-list.module.scss';
import { Icon, IconType } from '../icon/icon';
import { FormattedMessage, useIntl } from 'gatsby-plugin-react-intl';

interface IProps {
  data: {
    question: string;
    answer: string;
  }[];
}
export const QuestionsAnswersList = ({ data }: IProps) => {
  const intl = useIntl();

  return (
    <ul className={styles.list}>
      {data.map(item => (
        <li key={item.question}>
          <div className={`${styles.question} d-flex align-items-start`}>
            <Icon className={styles.icon} name={IconType.TRIANGLE} />
            <h2>
              <FormattedMessage id={item.question} />
            </h2>
          </div>
          <p
            dangerouslySetInnerHTML={{
              __html: intl.formatMessage({
                id: item.answer,
              }),
            }}
          />
        </li>
      ))}
    </ul>
  );
};
